<div class="login-sc">
  <cds-card customClass="custom-card" [width]="'560'" [height]="'auto'" data-test-data="cds-custom-card">
    <div class="login-container">
      <div>
        <div class="logo-container"><img src="{{ logoSrc }}" /></div>
        <div class="input-container">
          <div>
            <cds-button
              label="Login"
              severity="primary"
              testAttr="login-btn"
              width="320px"
              (btnClicked)="login()"
              data-test-data="login-button"
              [disabled]="isButtonDisabled"></cds-button>
          </div>
        </div>
      </div>
      <div class="footer-container">
        By clicking “Login” you accept our <span class="link">Terms of Use</span> and
        <span class="link">Privacy Policy.</span>
        <p class="footer-text" [innerHTML]="footerText"></p>
      </div>
    </div>
  </cds-card>
</div>
